import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    position: relative;
    z-index: 999;
    cursor: pointer;

    @media (max-width: 768px) {
      max-width: 70px;
    }
  }
`;
